import React from 'react';

import SpinnerV2 from 'common/SpinnerV2';
import MultipleSelect from 'common/ui/MultipleSelect';
import Text, { P } from 'common/ui/Text';
import styles from 'css-module/components/subdomain/admin/AdminQueue/SourceFilters/_SourceFilters.module.scss';

import type { Option } from 'common/ui/common/select/SelectCommon';

type Props = {
  loading?: boolean;
  error?: boolean;
  options: Option[];
  selectedOptions: Option[];
  filterLabel: string;
  onChange: (selectedIds: string[] | null) => void;
  saveError?: boolean;
  optionsPlacement?: 'top' | 'bottom' | 'left' | 'right';
};

const SourceFilter = ({
  loading,
  error,
  options,
  selectedOptions,
  filterLabel,
  onChange,
  saveError,
  optionsPlacement = 'bottom',
}: Props) => {
  return (
    <>
      {loading ? (
        <SpinnerV2 size="large" />
      ) : error ? (
        <P className={styles.error} variant="bodySm">
          Something went wrong fetching options, please contact support.
        </P>
      ) : (
        <form className={styles.form}>
          <Text as="label" className={styles.filterLabel} fontWeight="medium">
            {filterLabel}
          </Text>
          <MultipleSelect
            allowClear={true}
            onChange={(options: Option[]) => {
              const selectedIds =
                options.length === 0 ? null : options.map((option) => option.value);
              onChange(selectedIds);
            }}
            options={options}
            placeholder="Everything"
            value={selectedOptions}
            optionsPlacement={optionsPlacement}
          />
        </form>
      )}
      {saveError && (
        <P className={styles.error} variant="bodySm">
          Something went wrong, please contact support.
        </P>
      )}
    </>
  );
};

export default SourceFilter;
